var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21 27.25H45C46.5913 27.25 48.1174 27.8821 49.2426 29.0074C50.3679 30.1326 51 31.6587 51 33.25V51.25C51 51.6478 50.842 52.0294 50.5607 52.3107C50.2794 52.592 49.8978 52.75 49.5 52.75H25.5C23.9087 52.75 22.3826 52.1179 21.2574 50.9926C20.1321 49.8674 19.5 48.3413 19.5 46.75V28.75C19.5 28.3522 19.658 27.9706 19.9393 27.6893C20.2206 27.408 20.6022 27.25 21 27.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.25H45C46.5913 27.25 48.1174 27.8821 49.2426 29.0074C50.3679 30.1326 51 31.6587 51 33.25V51.25C51 51.6478 50.842 52.0294 50.5607 52.3107C50.2794 52.592 49.8978 52.75 49.5 52.75H25.5C23.9087 52.75 22.3826 52.1179 21.2574 50.9926C20.1321 49.8674 19.5 48.3413 19.5 46.75V28.75C19.5 28.3522 19.658 27.9706 19.9393 27.6893C20.2206 27.408 20.6022 27.25 21 27.25V27.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37L61.5 31V49L51 43",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircleIcon);
export default __webpack_public_path__ + "static/media/video_circle_icon.c53067ff8654df0f3985a8bd51c03780.svg";
export { ForwardRef as ReactComponent };